import React, { forwardRef } from 'react';

export interface ConversationActionMenuItem {
  label: string;
  icon: React.ReactNode;
  color: string;
  action: () => void;
}

export interface ConversationActionMenuProps {
  items: ConversationActionMenuItem[];
  fontFamily?: string;
  style?: React.CSSProperties;
  className?: string;
}

const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M7.1478e-07 9.99805V9.83203C7.1478e-07 9.46476 0.29777 9.16699 0.66504 9.16699C1.03231 9.16699 1.33008 9.46476 1.33008 9.83203V9.99805C1.33008 10.7089 1.33099 11.2025 1.36231 11.5859C1.39299 11.9615 1.44982 12.1731 1.53027 12.3311L1.60059 12.458C1.7769 12.7454 2.02992 12.9799 2.33203 13.1338L2.46191 13.1895C2.60569 13.2409 2.7952 13.2787 3.07715 13.3018C3.46067 13.3331 3.954 13.333 4.66504 13.333H9.99805C10.7089 13.333 11.2025 13.3331 11.5859 13.3018C11.9613 13.2711 12.1731 13.2142 12.3311 13.1338L12.458 13.0625C12.7454 12.8862 12.9799 12.6331 13.1338 12.3311L13.1895 12.2012C13.2409 12.0574 13.2787 11.8677 13.3018 11.5859C13.3331 11.2025 13.333 10.7089 13.333 9.99805V9.83203C13.333 9.46487 13.6309 9.16717 13.998 9.16699C14.3653 9.16699 14.6631 9.46476 14.6631 9.83203V9.99805C14.6631 10.6871 14.6637 11.2441 14.627 11.6943C14.5942 12.0953 14.5292 12.4565 14.3848 12.793L14.3184 12.9355C14.0529 13.4565 13.649 13.8922 13.1533 14.1963L12.9355 14.3184C12.5588 14.5103 12.1523 14.5895 11.6943 14.627C11.2441 14.6637 10.6871 14.6631 9.99805 14.6631H4.66504C3.97595 14.6631 3.41899 14.6637 2.96875 14.627C2.56821 14.5942 2.20731 14.5299 1.87109 14.3857L1.72852 14.3184C1.2074 14.0528 0.770898 13.6491 0.466798 13.1533L0.344727 12.9355C0.152758 12.5588 0.073554 12.1523 0.0361335 11.6943C-0.000636417 11.2441 7.1478e-07 10.687 7.1478e-07 9.99805ZM6.66699 9.83203V2.27051L4.46875 4.46875C4.20911 4.72839 3.78803 4.72829 3.52832 4.46875C3.26862 4.20905 3.26862 3.78802 3.52832 3.52832L6.86133 0.194336L6.96289 0.111328C7.07128 0.0391338 7.19987 9.45271e-09 7.33203 0C7.50813 8.62398e-05 7.67715 0.0699043 7.80176 0.194336L11.1357 3.52832C11.3951 3.78799 11.3952 4.20915 11.1357 4.46875C10.876 4.72845 10.454 4.72845 10.1943 4.46875L7.99707 2.27148V9.83203C7.9969 10.199 7.69904 10.4969 7.33203 10.4971C6.96487 10.4971 6.66717 10.1992 6.66699 9.83203Z"
      fill="currentColor"
    />
  </svg>
);

const RenameIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.5416 1.1557L14.046 0.66012C13.2991 -0.0867392 12.0776 -0.0867392 11.3308 0.66012L4.13441 7.87045C3.93199 8.07287 3.80635 8.33811 3.77843 8.62429L3.58997 10.6694C3.56903 10.9277 3.65977 11.179 3.84125 11.3674C4.00877 11.5349 4.22515 11.6257 4.45549 11.6257H4.53227L6.57741 11.4372C6.86359 11.4093 7.12883 11.2837 7.33125 11.0812L14.5346 3.8779C14.8976 3.51494 15.1 3.03332 15.1 2.52378C15.1 2.01424 14.8976 1.52564 14.5346 1.16966L14.5416 1.1557ZM6.59835 10.3344C6.59835 10.3344 6.52855 10.3832 6.49365 10.3832L4.65791 10.5508L4.82543 8.71503C4.82543 8.67315 4.84637 8.63825 4.87429 8.60335L10.7235 2.75412L12.4476 4.47817L6.59835 10.3274V10.3344ZM13.8017 3.13104L13.1875 3.74528L11.4634 2.02122L12.0776 1.40698C12.2452 1.23946 12.4685 1.14872 12.6919 1.14872C12.9152 1.14872 13.1386 1.23248 13.3061 1.40698L13.8017 1.90256C13.9692 2.07008 14.06 2.28646 14.06 2.5168C14.06 2.74714 13.9692 2.9705 13.8017 3.13104ZM13.711 8.43583V12.4912C13.711 13.9361 12.5383 15.1087 11.0935 15.1087H2.71747C1.27261 15.1087 0.0999756 13.9361 0.0999756 12.4912V4.11522C0.0999756 2.67036 1.27261 1.49772 2.71747 1.49772H6.77285C7.05903 1.49772 7.29635 1.73504 7.29635 2.02122C7.29635 2.3074 7.05903 2.54472 6.77285 2.54472H2.71747C1.85195 2.54472 1.14697 3.2497 1.14697 4.11522V12.4912C1.14697 13.3567 1.85195 14.0617 2.71747 14.0617H11.0935C11.959 14.0617 12.664 13.3567 12.664 12.4912V8.43583C12.664 8.14965 12.9013 7.91233 13.1875 7.91233C13.4736 7.91233 13.711 8.14965 13.711 8.43583Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
  </svg>
);

const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="5 4 14 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.39474 9.11443C7.71533 9.12219 7.96889 9.3867 7.96108 9.70524L7.38061 9.69119L6.80013 9.67713C6.80794 9.3586 7.07416 9.10668 7.39474 9.11443ZM7.38061 9.69119C6.80013 9.67714 6.80013 9.67713 6.80013 9.67713L6.79936 9.70993L6.79726 9.80316C6.7955 9.88421 6.79306 10.0018 6.79035 10.1485C6.78493 10.4418 6.77844 10.8518 6.7741 11.3183C6.76546 12.2486 6.76533 13.4138 6.80038 14.3285C6.83872 15.329 6.94195 16.6241 7.02712 17.5884C7.12331 18.6775 8.04392 19.4989 9.13533 19.4989H14.8548C15.9462 19.4989 16.8669 18.6775 16.9631 17.5884C17.0482 16.6241 17.1515 15.329 17.1898 14.3285C17.2248 13.4138 17.2247 12.2486 17.2161 11.3183C17.2117 10.8518 17.2053 10.4418 17.1999 10.1485C17.1971 10.0018 17.1947 9.88421 17.1929 9.80316L17.1909 9.70993L17.19 9.67774C17.1822 9.35921 16.916 9.10668 16.5954 9.11443C16.2748 9.12219 16.0213 9.3867 16.0291 9.70524L16.399 9.69628C16.0291 9.70524 16.0291 9.70524 16.0291 9.70524L16.0299 9.73653L16.0319 9.82812C16.0336 9.90803 16.0361 10.0244 16.0387 10.1697C16.0441 10.4603 16.0506 10.8666 16.0548 11.3289C16.0635 12.2559 16.0633 13.3985 16.0293 14.2847C15.9922 15.2548 15.8912 16.5257 15.8062 17.4875C15.7635 17.972 15.3531 18.345 14.8548 18.345H9.13533C8.63703 18.345 8.22675 17.972 8.18396 17.4875C8.09901 16.5257 7.99801 15.2548 7.96083 14.2847C7.92687 13.3985 7.92673 12.2559 7.93534 11.3289C7.93964 10.8666 7.94608 10.4603 7.95145 10.1697C7.95413 10.0244 7.95655 9.90803 7.95829 9.82812L7.96033 9.73653L7.96108 9.70524L7.38061 9.69119Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.995 7.38344C5.995 7.06482 6.25496 6.80652 6.57564 6.80652H17.4143C17.735 6.80652 17.995 7.06482 17.995 7.38344C17.995 7.70207 17.735 7.96037 17.4143 7.96037H6.57564C6.25496 7.96037 5.995 7.70207 5.995 7.38344Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.18745 5.61881C9.55746 4.92948 10.2797 4.4989 11.066 4.4989H12.9241C13.7104 4.4989 14.4326 4.92948 14.8027 5.61881L15.6041 7.11202C15.7551 7.39317 15.648 7.74263 15.3651 7.89257C15.0821 8.04251 14.7304 7.93615 14.5795 7.65501L13.7779 6.16179C13.6098 5.84847 13.2814 5.65275 12.9241 5.65275H11.066C10.7086 5.65275 10.3803 5.84847 10.2121 6.16179L9.4106 7.65501C9.25969 7.93615 8.90797 8.04251 8.62502 7.89257C8.34207 7.74263 8.23502 7.39317 8.38593 7.11202L9.18745 5.61881Z"
      fill="currentColor"
    />
  </svg>
);

const DELETE_COLOR = '#dc2626';

export function buildConversationMenuItems({
  onShare,
  onRename,
  onDelete,
  defaultColor,
}: {
  onShare: () => void;
  onRename: () => void;
  onDelete: () => void;
  defaultColor: string;
}): ConversationActionMenuItem[] {
  return [
    { label: 'Share', icon: <ShareIcon />, color: defaultColor, action: onShare },
    { label: 'Rename', icon: <RenameIcon />, color: defaultColor, action: onRename },
    { label: 'Delete', icon: <DeleteIcon />, color: DELETE_COLOR, action: onDelete },
  ];
}

export const ConversationActionMenu = forwardRef<HTMLDivElement, ConversationActionMenuProps>(
  ({ items, fontFamily, style, className }, ref) => {
    return (
      <div
        ref={ref}
        className={className}
        style={{
          backgroundColor: '#ffffff',
          borderRadius: 5,
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          padding: '4px',
          border: '1px solid rgba(0,0,0,0.08)',
          minWidth: 140,
          ...(fontFamily && fontFamily !== 'inherit' ? { fontFamily } : {}),
          ...style,
        }}
      >
        {items.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              item.action();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              padding: '4px 8px',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              backgroundColor: 'transparent',
              textAlign: 'left',
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'inherit',
              color: item.color,
              lineHeight: '24px',
              whiteSpace: 'nowrap',
              transition: 'background-color 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {item.icon}
            {item.label}
          </button>
        ))}
      </div>
    );
  },
);

ConversationActionMenu.displayName = 'ConversationActionMenu';
